GraphQL ID: presetExtras
list:

  - name: Power (Fractal)
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {}
          },
          "Sigil1": {
            "force": {},
            "accuracy": {}
          },
          "Sigil2": {
            "impact/night/slaying-both": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        }
      }

  - name: Power (Fractal, fireworks)
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "fireworks-relic": {
              "amount": "100"
            }
          },
          "Sigil1": {
            "force": {},
            "accuracy": {}
          },
          "Sigil2": {
            "impact/night/slaying-both": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        }
      }

  - name: Power (Fractal, claw)
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "claw-relic": {
              "amount": "100"
            },
            "mistburn-relic": {}
          },
          "Sigil1": {
            "force": {},
            "accuracy": {}
          },
          "Sigil2": {
            "impact/night/slaying-both": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        }
      }

  - name: Power (Fractal, bloodstone 0.6)
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "bloodstone-relic": {
              "amount": "0.6"
            }
          },
          "Sigil1": {
            "force": {},
            "accuracy": {}
          },
          "Sigil2": {
            "impact/night/slaying-both": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        }
      }

  - name: Power (Raid)
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {}
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power (Raid, fireworks)
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "fireworks-relic": {
              "amount": "100"
            }
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "furious-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power (Raid, claw)
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "claw-relic": {
              "amount": "100"
            },
            "mistburn-relic": {}
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "furious-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power (Raid, furious)
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {}
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "furious-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power (Raid, air)
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {}
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {},
            "air": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power (Raid, bloodstone 0.6)
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "bloodstone-relic": {
              "amount": "0.6"
            }
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Bladesworn (Fractal, placeholder relic)
    profession: Bladesworn
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "no-item-relic": {}
          },
          "Sigil1": {
            "force": {},
            "accuracy": {}
          },
          "Sigil2": {
            "impact/night/slaying-both": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": "3.8"
      }

  - name: Bladesworn (Raid, placeholder relic)
    profession: Bladesworn
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "no-item-relic": {}
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "furious-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": "3.8"
      }

  # air-only approximation of air/hydro split
  - name: Power Berserker
    profession: Berserker
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {}
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {},
            "air": {
              "amount": "4.1"
            }
          },
          "Enhancement": {
            "superior-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Boon (Raid)
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {},
            "pack": {},
            "fireworks": {},
            "leadership": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {}
          },
          "Sigil1": {
            "force": {},
            "accuracy": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {},
            "concentration": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "furious-sharpening-stone": {},
            "holographic-super-cheese": {},
            "potent-lucent-oil": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "plate-of-beef-carpaccio-with-salsa-garnish": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Boon (Fractal)
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {},
            "pack": {},
            "fireworks": {},
            "leadership": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {}
          },
          "Sigil1": {
            "force": {},
            "accuracy": {},
            "concentration": {}
          },
          "Sigil2": {
            "impact/night/slaying-both": {},
            "accuracy": {},
            "concentration": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "plate-of-beef-carpaccio-with-salsa-garnish": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Boon (Raid, fireworks)
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {},
            "pack": {},
            "fireworks": {},
            "leadership": {}
          },
          "Relics": {
            "fireworks-relic": {
              "amount": "100"
            }
          },
          "Sigil1": {
            "force": {},
            "accuracy": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {},
            "concentration": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "furious-sharpening-stone": {},
            "holographic-super-cheese": {},
            "potent-lucent-oil": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "plate-of-beef-carpaccio-with-salsa-garnish": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Boon (Fractal, fireworks)
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {},
            "pack": {},
            "fireworks": {},
            "leadership": {}
          },
          "Relics": {
            "fireworks-relic": {
              "amount": "100"
            }
          },
          "Sigil1": {
            "force": {},
            "accuracy": {},
            "concentration": {}
          },
          "Sigil2": {
            "impact/night/slaying-both": {},
            "accuracy": {},
            "concentration": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "plate-of-beef-carpaccio-with-salsa-garnish": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Boon (Raid, claw)
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {},
            "pack": {},
            "fireworks": {},
            "leadership": {}
          },
          "Relics": {
            "claw-relic": {
              "amount": "100"
            },
            "mistburn-relic": {}
          },
          "Sigil1": {
            "force": {},
            "accuracy": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {},
            "concentration": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "furious-sharpening-stone": {},
            "holographic-super-cheese": {},
            "potent-lucent-oil": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "plate-of-beef-carpaccio-with-salsa-garnish": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Boon (Fractal, claw)
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {},
            "pack": {},
            "fireworks": {},
            "leadership": {}
          },
          "Relics": {
            "claw-relic": {
              "amount": "100"
            },
            "mistburn-relic": {}
          },
          "Sigil1": {
            "force": {},
            "accuracy": {},
            "concentration": {}
          },
          "Sigil2": {
            "impact/night/slaying-both": {},
            "accuracy": {},
            "concentration": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "plate-of-beef-carpaccio-with-salsa-garnish": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Boon Power Chrono (Raid)
    profession: Chronomancer
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {},
            "pack": {},
            "fireworks": {},
            "leadership": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {},
            "claw-relic": {
              "amount": "89"
            }
          },
          "Sigil1": {
            "force": {},
            "accuracy": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {},
            "concentration": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "furious-sharpening-stone": {},
            "holographic-super-cheese": {},
            "potent-lucent-oil": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "plate-of-beef-carpaccio-with-salsa-garnish": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Boon Power Chrono (Fractal)
    profession: Chronomancer
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {},
            "claw-relic": {
              "amount": "89"
            }
          },
          "Sigil1": {
            "force": {},
            "accuracy": {},
            "concentration": {}
          },
          "Sigil2": {
            "impact/night/slaying-both": {},
            "accuracy": {},
            "concentration": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "plate-of-beef-carpaccio-with-salsa-garnish": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Chrono DT (Fractal)
    profession: Chronomancer
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {},
            "claw-relic": {
              "amount": "92.1"
            }
          },
          "Sigil1": {
            "force": {},
            "accuracy": {},
          },
          "Sigil2": {
            "impact/night/slaying-both": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "plate-of-beef-carpaccio-with-salsa-garnish": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Chrono DT (Raid)
    profession: Chronomancer
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {},
            "claw-relic": {
              "amount": "92.1"
            }
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "furious-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Chrono IA (Fractal)
    profession: Chronomancer
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {},
            "fireworks-relic": {
              "amount": "94"
            }
          },
          "Sigil1": {
            "force": {},
            "accuracy": {},
          },
          "Sigil2": {
            "impact/night/slaying-both": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "plate-of-beef-carpaccio-with-salsa-garnish": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Chrono IA (Raid)
    profession: Chronomancer
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {},
            "fireworks-relic": {
              "amount": "94"
            }
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "furious-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  # no item sigil represents use of water/paralyzation/etc sigil
  - name: Heal
    value:
      {
        "extras": {
          "Runes": {
            "monk": {},
            "water": {}
          },
          "Relics": {},
          "Sigil1": {
            "no-item-sigil": {}
          },
          "Sigil2": {
            "transference": {}
          },
          "Enhancement": {
            "bountiful-maintenance-oil": {}
          },
          "Nourishment": {
            "fruit-salad-mint-garnish": {},
            "mint-creme-brulee": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Heal (concentration)
    value:
      {
        "extras": {
          "Runes": {
            "monk": {},
            "water": {}
          },
          "Relics": {},
          "Sigil1": {
            "concentration": {}
          },
          "Sigil2": {
            "transference": {}
          },
          "Enhancement": {
            "bountiful-maintenance-oil": {}
          },
          "Nourishment": {
            "fruit-salad-mint-garnish": {},
            "mint-creme-brulee": {}
          }
        },
        "lifestealAmount": ""
      }


  - name: Alacrity Condi Mirage Staff
    profession: Mirage
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "weaver": {},
            "berserker": {},
            "renegade": {},
            "leadership": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            }
          },
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "no-item-sigil": {}
          },
          "Enhancement": {
            "toxic-maintenance-oil": {},
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "salsa-topped-veggie-flatbread": {},
            "meaty-asparagus-skewer": {},
            "meaty-rice-bowl": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: DPS Mirage (Raid)
    profession: Mirage
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "weaver": {},
            "berserker": {},
            "renegade": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": "0.475"
            }
          },
          "Sigil1": {
            "no-item-sigil": {}
          },
          "Sigil2": {
            "no-item-sigil": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "salsa-topped-veggie-flatbread": {},
            "meaty-asparagus-skewer": {},
            "meaty-rice-bowl": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Mirage (Fractal)
    profession: Mirage
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "peitha-relic": {
              "amount": "1.9"
            }
          },
          "Sigil1": {
            "force": {},
            "accuracy": {}
          },
          "Sigil2": {
            "impact/night/slaying-both": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Mirage (Raid)
    profession: Mirage
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "peitha-relic": {
              "amount": "1.9"
            }
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "furious-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Boon Condi Chrono Scepter
    profession: Chronomancer
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "mischief-ineptitude": {
              "amount": "0.9"
            },
            "concentration": {}
          },
          "Runes": {
            "perplexity": {}
          },
          "Relics": {},
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "spherified-cilantro-oyster-soup": {}
          },
          "Enhancement": {
            "toxic-focusing-crystal": {},
            "master-tuning-crystal": {}
          }
        }
      }

  # both boon and dps
  - name: Condi Chrono Staff SC/D
    profession: Chronomancer
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {},
            "malice": {},
            "demons": {}
          },
          "Sigil2": {
            "no-item-sigil": {}
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "tormenting": {}
          },
          "Relics": {
            "no-item-relic": {}
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "salsa-topped-veggie-flatbread": {},
            "meaty-asparagus-skewer": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Chrono Scepter (Approx.)
    profession: Chronomancer
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "weaver": {},
            "berserker": {},
            "renegade": {},
            "leadership": {}
          },
          "Relics": {
            "no-item-relic": {}
          },
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "no-item-sigil": {}
          },
          "Enhancement": {
            "toxic-focusing-crystal": {},
            "master-tuning-crystal": {}
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "salsa-topped-veggie-flatbread": {},
            "meaty-asparagus-skewer": {},
            "meaty-rice-bowl": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Chrono DPS
    profession: Chronomancer
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "mischief-ineptitude": {
              "amount": "0.9"
            }
          },
          "Runes": {
            "perplexity": {}
          },
          "Relics": {},
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {}
          },
          "Enhancement": {
            "toxic-focusing-crystal": {},
            "master-tuning-crystal": {}
          }
        }
      }

  - name: Condi Virtuoso Dueling
    profession: Virtuoso
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {},
            "agony": {}
          },
          "Sigil2": {
            "earth": {
              "amount": "4.3"
            }
          },
          "Runes": {
            "krait": {}
          },
          "Relics": {
            "aristocracy-relic": {}
          },
          "Nourishment": {
            "plate-of-kimchi-pancakes": {},
            "fancy-potato-and-leek-soup": {},
            "spherified-cilantro-oyster-soup": {}
          },
          "Enhancement": {
            "toxic-focusing-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Virtuoso Chaos
    profession: Virtuoso
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "earth": {
              "amount": "4.3"
            }
          },
          "Runes": {
            "krait": {}
          },
          "Relics": {},
          "Nourishment": {
            "spherified-cilantro-oyster-soup": {},
            "fancy-potato-and-leek-soup": {},
            "truffle-risotto": {}
          },
          "Enhancement": {
            "toxic-focusing-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Quickbrand (Raid)
    profession: Firebrand
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {},
            "pack": {},
            "fireworks": {},
            "firebrand": {}
          },
          "Relics": {},
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {},
            "concentration": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Dragonhunter Radiance (Fractal)
    profession: Dragonhunter
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {},
            "dragonhunter-relic": {
              "amount": "89"
            }
          },
          "Sigil1": {
            "force": {},
            "accuracy": {}
          },
          "Sigil2": {
            "impact/night/slaying-both": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        }
      }

  - name: Power Dragonhunter Radiance (Raid)
    profession: Dragonhunter
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {},
            "dragonhunter-relic": {
              "amount": "89"
            }
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Dragonhunter Virtues (Raid)
    profession: Dragonhunter
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {},
            "dragonhunter-relic": {
              "amount": "78"
            }
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "furious-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Dragonhunter Virtues (Fractal)
    profession: Dragonhunter
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {},
            "dragonhunter-relic": {
              "amount": "78"
            }
          },
          "Sigil1": {
            "force": {},
            "accuracy": {}
          },
          "Sigil2": {
            "impact/night/slaying-both": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {}
          }
        }
      }

  - name: Power Willbender Virtues (Fractal)
    profession: Willbender
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {}
          },
          "Sigil1": {
            "force": {},
            "accuracy": {}
          },
          "Sigil2": {
            "impact/night/slaying-both": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {}
          }
        }
      }

  - name: Power Alacrity Willbender (Raid)
    profession: Willbender
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {},
            "pack": {},
            "leadership": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {}
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "accuracy": {}
          },
          "Enhancement": {
            "furious-sharpening-stone": {},
            "superior-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Alacrity Willbender Warrior (Raid)
    profession: Willbender
    value:
      {
        "extras":
          {
            "Runes":
              {
                "scholar": {},
                "dragonhunter": {},
                "golemancer": {},
                "deadeye": {},
                "eagle": {},
                "infiltration": {},
                "ranger": {},
                "pack": {},
                "leadership": {}
              },
            "Relics": {},
            "Sigil1": {"force": {}},
            "Sigil2": {"accuracy": {}},
            "Enhancement": {"furious-sharpening-stone": {}, "superior-sharpening-stone": {}},
            "Nourishment": {"cilantro-lime-sous-vide-steak": {}, "spherified-cilantro-oyster-soup": {}}
          },
        "lifestealAmount": ""
      }

  - name: Power Alacrity Willbender Warrior (Fractal)
    profession: Willbender
    value:
      {
        "extras":
          {
            "Runes":
              {
                "scholar": {},
                "dragonhunter": {},
                "golemancer": {},
                "deadeye": {},
                "eagle": {},
                "infiltration": {},
                "ranger": {},
                "pack": {},
                "leadership": {}
              },
            "Relics": {},
            "Sigil1": {"force": {}},
            "Sigil2": {"accuracy": {}},
            "Enhancement": {"furious-sharpening-stone": {}, "superior-sharpening-stone": {}, "slaying-potion": {}},
            "Nourishment": {"cilantro-lime-sous-vide-steak": {}, "spherified-cilantro-oyster-soup": {}}
          },
        "lifestealAmount": ""
      }

  - name: Condi Willbender
    profession: Willbender
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "no-item-sigil": {}
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "balthazar": {},
            "renegade": {},
            "berserker": {},
            "weaver": {},
            "baelfire": {},
            "flame-legion-2": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            }
          },
          "Nourishment": {
            "fishy-rice-bowl": {},
            "cilantro-and-cured-meat-flatbread": {}
          },
          "Enhancement": {
            "toxic-focusing-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Willbender Warrior
    profession: Willbender
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "no-item-sigil": {}
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "balthazar": {},
            "renegade": {},
            "berserker": {},
            "weaver": {},
            "baelfire": {},
            "flame-legion-2": {}
          },
          "Relics": {},
          "Nourishment": {
            "fishy-rice-bowl": {},
            "cilantro-and-cured-meat-flatbread": {}
          },
          "Enhancement": {
            "toxic-focusing-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Alacrity Willbender
    profession: Willbender
    value:
      {
        "extras":
          {
            "Sigil1": {"bursting": {}},
            "Sigil2": {"geomancy-torment-cwb-alac": {}, "smoldering": {}},
            "Runes": {"trapper": {}, "nightmare": {}, "balthazar": {}, "leadership": {}},
            "Relics": {"fractal-relic": {}},
            "Nourishment":
              {
                "fishy-rice-bowl": {},
                "cilantro-and-cured-meat-flatbread": {},
                "spherified-cilantro-oyster-soup": {}
              },
            "Enhancement": {"toxic-maintenance-oil": {}, "toxic-focusing-crystal": {}, "magnanimous-tuning-crystal": {}}
          },
        "lifestealAmount": ""
      }

  - name: Condi Firebrand
    profession: Firebrand
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "balthazar": {},
            "renegade": {},
            "berserker": {},
            "weaver": {},
            "baelfire": {},
            "flame-legion-2": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            },
            "aristocracy-relic": {}
          },
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "smoldering": {},
            "malice": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "fishy-rice-bowl": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Quickness Condi Firebrand
    profession: Firebrand
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "smoldering": {}
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "balthazar": {},
            "berserker": {},
            "firebrand": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": "0.41"
            }
          },
          "Nourishment": {
            "fishy-rice-bowl": {},
            "salsa-topped-veggie-flatbread": {},
            "cilantro-and-cured-meat-flatbread": {}
          },
          "Enhancement": {
            "toxic-focusing-crystal": {},
            "magnanimous-tuning-crystal": {},
            "toxic-maintenance-oil": {},
            "magnanimous-maintenance-oil": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Hybrid FB Traveler
    profession: Firebrand
    value:
      {
        "extras": {
          "Runes": {},
          "Relics": {},
          "Sigil1": {
            "bursting": {},
            "concentration": {}
          },
          "Sigil2": {
            "smoldering": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "magnanimous-maintenance-oil": {}
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Berserker
    profession: Berserker
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "balthazar": {},
            "renegade": {},
            "berserker": {},
            "weaver": {},
            "baelfire": {},
            "flame-legion-2": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            }
          },
          "Sigil1": {
            "no-item-sigil": {}
          },
          "Sigil2": {
            "no-item-sigil": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "salsa-topped-veggie-flatbread": {},
            "cilantro-and-cured-meat-flatbread": {}
          }
        },
        "lifestealAmount": "3.7"
      }

  - name: Condi Quickness Bers
    profession: Berserker
    value:
      {
        "extras": {
          "Runes": {
            "firebrand": {},
            "trapper": {},
            "nightmare": {},
            "tempest": {}
          },
          "Relics": {
            "fractal-relic": {}
          },
          "Sigil1": {
            "no-item-sigil": {}
          },
          "Sigil2": {
            "no-item-sigil": {}
          },
          "Enhancement": {
            "toxic-maintenance-oil": {},
            "master-tuning-crystal": {}
          },
          "Nourishment": {
            "salsa-topped-veggie-flatbread": {},
            "cilantro-and-cured-meat-flatbread": {},
            "spherified-cilantro-oyster-soup": {}
          }
        }
      }

  - name: Hybrid Paragon S/S
    profession: Paragon
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "krait": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            }
          },
          "Sigil1": {
            "torment": {
              "amount": ""
            },
            "earth": {
              "amount": ""
            },
            "bursting": {}
          },
          "Sigil2": {
            "torment": {
              "amount": ""
            },
            "earth": {
              "amount": ""
            },
            "bursting": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "spherified-cilantro-oyster-soup": {},
            "cilantro-and-cured-meat-flatbread": {},
            "plate-of-kimchi-pancakes": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Alacrity Fire Tempest Inferno (Fractal)
    profession: Tempest
    value:
      {
        "extras": {
          "Runes": {
            "flame-legion": {},
            "scholar": {},
            "deadeye": {},
            "infiltration": {}
          },
          "Relics": {
            "bloodstone-relic": {
              "amount": "0.47"
            },
            "fireworks-relic": {
              "amount": "100"
            },
            "relic-of-nourys": {
              "amount": "12.1"
            }
          },
          "Sigil1": {
            "force": {},
            "accuracy": {},
            "smoldering": {},
            "malice": {},
            "bursting": {}
          },
          "Sigil2": {
            "accuracy": {},
            "smoldering": {},
            "impact/night/slaying-both": {},
            "bursting": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "potent-lucent-oil": {},
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "truffle-steak": {},
            "fire-meat-chili": {},
            "plate-of-beef-carpaccio-with-salsa-garnish": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Alacrity Fire Tempest Inferno (Raid)
    profession: Tempest
    value:
      {
        "extras": {
          "Runes": {
            "flame-legion": {},
            "scholar": {},
            "deadeye": {},
            "infiltration": {}
          },
          "Relics": {
            "bloodstone-relic": {
              "amount": "0.47"
            },
            "fireworks-relic": {
              "amount": "100"
            },
            "relic-of-nourys": {
              "amount": "12.1"
            }
          },
          "Sigil1": {
            "force": {},
            "accuracy": {},
            "malice": {},
            "bursting": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "smoldering": {},
            "accuracy": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "potent-lucent-oil": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "truffle-steak": {},
            "fire-meat-chili": {},
            "plate-of-beef-carpaccio-with-salsa-garnish": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Tempest Inferno (Fractal)
    profession: Tempest
    value:
      {
        "extras": {
          "Runes": {
            "flame-legion": {},
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "fireworks-relic": {
              "amount": "100"
            }
          },
          "Sigil1": {
            "force": {},
            "accuracy": {},
            "smoldering": {},
            "bursting": {}
          },
          "Sigil2": {
            "accuracy": {},
            "smoldering": {},
            "impact/night/slaying-both": {},
            "bursting": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "truffle-steak": {},
            "fire-meat-chili": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Tempest Inferno (Raid)
    profession: Tempest
    value:
      {
        "extras": {
          "Runes": {
            "flame-legion": {},
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "fireworks-relic": {
              "amount": "100"
            }
          },
          "Sigil1": {
            "force": {},
            "accuracy": {},
            "bursting": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "smoldering": {},
            "accuracy": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "truffle-steak": {},
            "fire-meat-chili": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Weaver (Raid)
    profession: Weaver
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "fireworks-relic": {
              "amount": "92.5"
            }
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "furious-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        }
      }

  - name: Condi Weaver Sword
    profession: Weaver
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "balthazar": {},
            "renegade": {},
            "berserker": {},
            "weaver": {},
            "baelfire": {},
            "flame-legion-2": {}
          },
          "Relics": {},
          "Sigil1": {},
          "Sigil2": {},
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "salsa-topped-veggie-flatbread": {}
          }
        }
      }

  - name: Condi Weaver Dagger
    profession: Weaver
    value:
      {
        "extras": {
          "Sigil1": {
            "earth": {}
          },
          "Sigil2": {
            "bursting": {}
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "balthazar": {},
            "renegade": {},
            "berserker": {},
            "weaver": {},
            "baelfire": {},
            "flame-legion-2": {}
          },
          "Relics": {},
          "Nourishment": {
            "salsa-topped-veggie-flatbread": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          }
        }
      }

  # Torment procs chosen to make log get 0 stacks
  - name: Condi Weaver Scepter
    profession: Weaver
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "balthazar": {},
            "renegade": {},
            "berserker": {},
            "weaver": {},
            "baelfire": {},
            "flame-legion-2": {}
          },
          "Relics": {
            "fractal-relic": {}
          },
          "Sigil1": {
            "earth": {}
          },
          "Sigil2": {
            "smoldering": {},
            "bursting": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "salsa-topped-veggie-flatbread": {},
            "cilantro-and-cured-meat-flatbread": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Weaver
    profession: Weaver
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "balthazar": {},
            "renegade": {},
            "berserker": {},
            "weaver": {},
            "baelfire": {},
            "flame-legion-2": {}
          },
          "Relics": {
            "fractal-relic": {}
          },
          "Sigil1": {
            "earth": {
              "amount": ""
            }
          },
          "Sigil2": {
            "torment": {
              "amount": ""
            },
            "bursting": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "salsa-topped-veggie-flatbread": {},
            "cilantro-and-cured-meat-flatbread": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Hybrid Weaver (Fractal)
    profession: Weaver
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "balthazar": {},
            "renegade": {},
            "berserker": {},
            "weaver": {},
            "baelfire": {},
            "flame-legion-2": {}
          },
          "Relics": {},
          "Sigil1": {
            "impact/night/slaying-both": {}
          },
          "Sigil2": {
            "bursting": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "spherified-cilantro-oyster-soup": {}
          }
        }
      }

  - name: Hybrid Weaver (Raid)
    profession: Weaver
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "balthazar": {},
            "renegade": {},
            "berserker": {},
            "weaver": {},
            "baelfire": {},
            "flame-legion-2": {}
          },
          "Relics": {},
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "bursting": {}
          },
          "Enhancement": {
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "spherified-cilantro-oyster-soup": {}
          }
        }
      }

  - name: Alacrity Hybrid Tempest
    profession: Tempest
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "balthazar": {},
            "renegade": {},
            "berserker": {},
            "weaver": {},
            "baelfire": {},
            "flame-legion-2": {},
            "leadership": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": "0.4"
            }
          },
          "Sigil1": {
            "bursting": {},
            "smoldering": {}
          },
          "Sigil2": {
            "torment": {
              "amount": ""
            },
            "concentration": {}
          },
          "Enhancement": {
            "toxic-focusing-crystal": {},
            "toxic-maintenance-oil": {}
          },
          "Nourishment": {
            "spherified-cilantro-oyster-soup": {},
            "cilantro-and-cured-meat-flatbread": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Tempest
    profession: Tempest
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "balthazar": {},
            "renegade": {},
            "berserker": {},
            "weaver": {},
            "baelfire": {},
            "flame-legion-2": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            }
          },
          "Sigil1": {
            "smoldering": {},
            "bursting": {},
            "malice": {},
          },
          "Sigil2": {
             "earth": {},
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "salsa-topped-veggie-flatbread": {},
            "plate-of-kimchi-pancakes": {},
            "cilantro-and-cured-meat-flatbread": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Catalyst Scepter Inferno (Fractal)
    profession: Catalyst
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {},
            "malice": {},
            "force": {},
            "smoldering": {}
          },
          "Sigil2": {
            "bursting": {},
            "malice": {},
            "force": {},
            "smoldering": {},
            "impact/night/slaying-both": {}
          },
          "Runes": {
            "flame-legion": {}
          },
          "Relics": {
            "bloodstone-relic": {
              "amount": "0.72"
            }
          },
          "Nourishment": {
            "fire-meat-chili": {},
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "spherified-cilantro-oyster-soup": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "slaying-potion": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Catalyst Scepter Inferno (Raid)
    profession: Catalyst
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {},
            "malice": {},
            "force": {},
            "smoldering": {}
          },
          "Sigil2": {
            "bursting": {},
            "malice": {},
            "force": {},
            "smoldering": {}
          },
          "Runes": {
            "flame-legion": {}
          },
          "Relics": {
            "bloodstone-relic": {
              "amount": "0.72"
            }
          },
          "Nourishment": {
            "fire-meat-chili": {},
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "spherified-cilantro-oyster-soup": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Catalyst Scepter PF (Fractal)
    profession: Catalyst
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "bloodstone-relic": {
              "amount": "0.7"
            }
          },
          "Sigil1": {
            "force": {},
            "accuracy": {}
          },
          "Sigil2": {
            "impact/night/slaying-both": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Catalyst Scepter PF (Raid)
    profession: Catalyst
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "bloodstone-relic": {
              "amount": "0.7"
            }
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Quickness Catalyst Scepter PF (Fractal)
    profession: Catalyst
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {},
            "fireworks": {}
          },
          "Relics": {
            "bloodstone-relic": {
              "amount": "0.7"
            }
          },
          "Sigil1": {
            "force": {},
            "accuracy": {},
            "concentration": {}
          },
          "Sigil2": {
            "impact/night/slaying-both": {},
            "accuracy": {},
            "concentration": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Quickness Catalyst Scepter PF (Raid)
    profession: Catalyst
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {},
            "fireworks": {}
          },
          "Relics": {
            "bloodstone-relic": {
              "amount": "0.7"
            }
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {},
            "concentration": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  # quickness/dps
  - name: Condi Catalyst P/D
    profession: Catalyst
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "balthazar": {},
            "krait": {},
            "afflicted": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            },
            "steamshrieker-relic": {
              "amount": "4"
            }
          },
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "smoldering": {},
            "earth": {},
            "malice": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "salsa-topped-veggie-flatbread": {},
            "plate-of-kimchi-pancakes": {},
            "cilantro-and-cured-meat-flatbread": {},
            "fishy-rice-bowl": {}
          }
        },
        "lifestealAmount": ""
      }

  # quickness/dps
  - name: Condi Catalyst P/W
    profession: Catalyst
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "balthazar": {},
            "krait": {},
            "afflicted": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            }
          },
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "smoldering": {},
            "earth": {},
            "malice": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "salsa-topped-veggie-flatbread": {},
            "plate-of-kimchi-pancakes": {},
            "cilantro-and-cured-meat-flatbread": {},
            "fishy-rice-bowl": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Fire-only ele (Fractal)
    profession: Elementalist
    value:
      {
        "extras":
          {
            "Sigil1": {"bursting": {}, "malice": {}, "force": {}, "impact/night/slaying-both": {}},
            "Sigil2": {"smoldering": {}},
            "Runes": {"flame-legion": {}, "scholar": {}, "dragonhunter": {}},
            "Relics": {"fireworks-relic": {"amount": "100"}},
            "Nourishment":
              {
                "fire-meat-chili": {},
                "cilantro-lime-sous-vide-steak": {},
                "plate-of-coq-au-vin-with-salsa": {}
              },
            "Enhancement": {"superior-sharpening-stone": {}, "slaying-potion": {}}
          },
        "lifestealAmount": ""
      }

  - name: Fire-only ele (Raid)
    profession: Elementalist
    value:
      {
        "extras":
          {
            "Sigil1": {"bursting": {}, "malice": {}, "force": {}},
            "Sigil2": {"smoldering": {}},
            "Runes": {"flame-legion": {}},
            "Relics": {"fireworks-relic": {"amount": "100"}},
            "Nourishment":
              {
                "fire-meat-chili": {},
                "cilantro-lime-sous-vide-steak": {},
                "plate-of-coq-au-vin-with-salsa": {}
              },
            "Enhancement": {"superior-sharpening-stone": {}}
          },
        "lifestealAmount": ""
      }

  - name: Quickness Fire SE Evoker Condi
    profession: Evoker
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {},
            "malice": {},
            "smoldering": {},
            "torment": {
              "amount": ""
            }
          },
          "Sigil2": {
            "earth": {
              "amount": ""
            }
          },
          "Runes": {
            "firebrand": {},
            "balthazar": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            }
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "salsa-topped-veggie-flatbread": {},
            "fishy-rice-bowl": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Fire SE Evoker Condi
    profession: Evoker
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {},
            "malice": {},
            "smoldering": {},
            "torment": {
              "amount": ""
            }
          },
          "Sigil2": {
            "earth": {
              "amount": ""
            }
          },
          "Runes": {
            "balthazar": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            }
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "salsa-topped-veggie-flatbread": {},
            "fishy-rice-bowl": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Fire SE Evoker Trailblazer
    profession: Evoker
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {},
            "malice": {},
            "smoldering": {},
            "torment": {
              "amount": ""
            }
          },
          "Sigil2": {
            "earth": {
              "amount": ""
            }
          },
          "Runes": {
            "balthazar": {},
            "forgeman": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            }
          },
          "Nourishment": {
            "peppercorn-and-veggie-flatbread": {},
            "peppered-cured-meat-flatbread": {},
            "spherified-peppercorn-spiced-oyster-soup": {}
          },
          "Enhancement": {
            "magnanimous-tuning-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Evoker PF (Fractal)
    profession: Evoker
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "bloodstone-relic": {
              "amount": "0.7"
            },
            "fireworks-relic": {
              "amount": "100"
            }
          },
          "Sigil1": {
            "force": {},
            "accuracy": {}
          },
          "Sigil2": {
            "impact/night/slaying-both": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        }
      }

  - name: Power Evoker PF (Raid)
    profession: Evoker
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "bloodstone-relic": {
              "amount": "0.7"
            },
            "fireworks-relic": {
              "amount": "100"
            }
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "furious-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Evoker Hare Inferno (Fractal)
    profession: Evoker
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {},
            "malice": {},
            "force": {},
            "smoldering": {}
          },
          "Sigil2": {
            "bursting": {},
            "malice": {},
            "force": {},
            "smoldering": {},
            "impact/night/slaying-both": {}
          },
          "Runes": {
            "flame-legion": {},
            "scholar": {},
            "dragonhunter": {}
          },
          "Relics": {
            "fireworks-relic": {
              "amount": "100"
            }
          },
          "Nourishment": {
            "fire-meat-chili": {},
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Evoker Hare Inferno (Raid)
    profession: Evoker
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {},
            "malice": {},
            "force": {},
            "smoldering": {}
          },
          "Sigil2": {
            "bursting": {},
            "malice": {},
            "force": {},
            "smoldering": {},
            "impact/night/slaying-only-3": {}
          },
          "Runes": {
            "flame-legion": {},
            "scholar": {},
            "dragonhunter": {}
          },
          "Relics": {
            "fireworks-relic": {
              "amount": "100"
            }
          },
          "Nourishment": {
            "fire-meat-chili": {},
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Evoker
    profession: Evoker
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {},
            "malice": {},
            "smoldering": {},
            "agony": {}
          },
          "Sigil2": {
            "bursting": {},
            "malice": {},
            "smoldering": {},
            "agony": {}
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "balthazar": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            }
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "salsa-topped-veggie-flatbread": {},
            "fishy-rice-bowl": {},
            "plate-of-kimchi-pancakes": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Quickness Condi Untamed
    profession: Untamed
    value:
      {
        "extras": {
          "Sigil1": {
            "malice": {},
            "earth": {},
            "bursting": {},
            "agony": {}
          },
          "Sigil2": {
            "malice": {},
            "earth": {},
            "bursting": {},
            "agony": {}
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "krait": {},
            "mad-king": {},
            "afflicted": {},
            "thorns": {},
            "firebrand": {}
          },
          "Relics": {
            "fractal-relic": {}
          },
          "Nourishment": {
            "plate-of-kimchi-pancakes": {},
            "salsa-topped-veggie-flatbread": {},
            "cilantro-and-cured-meat-flatbread": {},
            "bowl-of-kimchi-tofu-stew": {}
          },
          "Enhancement": {
            "toxic-focusing-crystal": {},
            "magnanimous-tuning-crystal": {},
            "master-tuning-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Quickness Untamed (Raid)
    profession: Untamed
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {},
            "pack": {},
            "fireworks": {},
            "firebrand": {}
          },
          "Relics": {
            "claw-relic": {
              "amount": "100"
            }
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "air": {
              "amount": ""
            },
            "accuracy": {},
            "impact/night/slaying-only-3": {},
            "concentration": {}
          },
          "Enhancement": {
            "potent-lucent-oil": {},
            "superior-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Untamed (Fractal)
    profession: Untamed
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "dragonhunter-relic": {
              "amount": "89"
            }
          },
          "Sigil1": {
            "force": {},
            "accuracy": {}
          },
          "Sigil2": {
            "impact/night/slaying-both": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Untamed (Raid)
    profession: Untamed
    value:
      {
        "extras":
          {
            "Runes":
              {
                "scholar": {},
                "dragonhunter": {},
                "golemancer": {},
                "deadeye": {},
                "eagle": {},
                "infiltration": {},
                "ranger": {}
              },
            "Relics": {"dragonhunter-relic": {"amount": "89"}},
            "Sigil1": {"force": {}},
            "Sigil2": {"impact-only-3-hydro-galeshot": {}},
            "Enhancement": {"superior-sharpening-stone": {}},
            "Nourishment":
              {
                "cilantro-lime-sous-vide-steak": {},
                "plate-of-coq-au-vin-with-salsa": {},
                "curry-butternut-squash-soup": {}
              }
          },
        "lifestealAmount": ""
      }

  - name: Condi Slb
    profession: Soulbeast
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {},
            "earth": {}
          },
          "Sigil2": {
            "agony": {},
            "earth": {},
            "malice": {}
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "renegade": {},
            "berserker": {},
            "krait": {},
            "mad-king": {},
            "afflicted": {},
            "thorns": {}
          },
          "Relics": {
            "fractal-relic": {}
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "salsa-topped-veggie-flatbread": {},
            "bowl-of-kimchi-tofu-stew": {},
            "plate-of-kimchi-pancakes": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Hybrid Slb
    profession: Soulbeast
    value:
      {
        "extras": {
          "Sigil1": {
            "earth": {}
          },
          "Sigil2": {
            "bursting": {}
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "renegade": {},
            "berserker": {},
            "krait": {},
            "mad-king": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            }
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "plate-of-kimchi-pancakes": {},
            "spherified-cilantro-oyster-soup": {}
          },
          "Enhancement": {
            "toxic-focusing-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Druid
    profession: Druid
    value:
      {
        "extras": {
          "Sigil1": {
            "agony": {},
            "bursting": {},
            "malice": {}
          },
          "Sigil2": {
            "no-item-sigil": {}
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "krait": {},
            "afflicted": {}
          },
          "Relics": {
            "fractal-relic": {}
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "salsa-topped-veggie-flatbread": {},
            "plate-of-kimchi-pancakes": {},
            "bowl-of-kimchi-tofu-stew": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Galeshot (Raid)
    profession: Galeshot
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "claw-relic": {
              "amount": "100"
            },
            "mistburn-relic": {}
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {},
            "impact-only-3-hydro-galeshot": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "furious-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Holo (Raid)
    profession: Holosmith
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "fireworks-relic": {
              "amount": "92.6"
            }
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Holo
    profession: Holosmith
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "balthazar": {},
            "renegade": {},
            "berserker": {},
            "weaver": {},
            "baelfire": {},
            "flame-legion-2": {}
          },
          "Relics": {
            "fractal-relic": {}
          },
          "Sigil1": {
            "malice": {},
            "earth": {}
          },
          "Sigil2": {
            "bursting": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {}
          }
        }
      }

  - name: Quickness Condi Scrapper
    profession: Scrapper
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {}
          },
          "Relics": {
            "steamshrieker-relic": {
              "amount": "5.3"
            },
            "fractal-relic": {
              "amount": ""
            }
          },
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "bursting": {},
            "geomancy": {
              "amount": ""
            },
            "earth": {
              "amount": ""
            },
            "doom": {
              "amount": ""
            },
            "torment": {
              "amount": ""
            }
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "salsa-topped-veggie-flatbread": {},
            "cilantro-and-cured-meat-flatbread": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Alacrity Condi Renegade
    profession: Renegade
    value:
      {
        "extras": {
          "Sigil1": {
            "no-item-sigil": {}
          },
          "Sigil2": {
            "no-item-sigil": {}
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "renegade": {},
            "berserker": {},
            "weaver": {},
            "leadership": {}
          },
          "Relics": {
            "fractal-relic": {}
          },
          "Nourishment": {
            "meaty-asparagus-skewer": {},
            "salsa-eggs-benedict": {},
            "spherified-cilantro-oyster-soup": {},
            "cilantro-and-cured-meat-flatbread": {}
          },
          "Enhancement": {
            "toxic-maintenance-oil": {},
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {},
            "magnanimous-tuning-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Renegade
    profession: Renegade
    value:
      {
        "extras": {
          "Sigil1": {
            "no-item-sigil": {}
          },
          "Sigil2": {
            "no-item-sigil": {}
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "weaver": {},
            "berserker": {},
            "renegade": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            }
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "meaty-asparagus-skewer": {},
            "salsa-topped-veggie-flatbread": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          }
        },
        "lifestealAmount": "4.4"
      }

  - name: Power Quickness Herald (Raid)
    profession: Herald
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {},
            "pack": {},
            "fireworks": {},
            "firebrand": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {}
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "air": {
              "amount": ""
            },
            "accuracy": {},
            "impact/night/slaying-only-3": {},
            "concentration": {}
          },
          "Enhancement": {
            "potent-lucent-oil": {},
            "superior-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Quickness Herald (Fractal)
    profession: Herald
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {},
            "pack": {},
            "fireworks": {},
            "firebrand": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {}
          },
          "Sigil1": {
            "force": {},
            "accuracy": {}
          },
          "Sigil2": {
            "impact/night/slaying-both": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Alacrity Power Renegade (Raid)
    profession: Renegade
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {}
          },
          "Relics": {
            "thief-relic": {
              "amount": ""
            }
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "air": {},
            "concentration": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {},
            "holographic-super-cheese": {},
            "potent-lucent-oil": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-beef-carpaccio-with-salsa-garnish": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Quickness Herald
    profession: Herald
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "renegade": {},
            "berserker": {},
            "weaver": {},
            "firebrand": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            }
          },
          "Sigil1": {
            "no-item-sigil": {}
          },
          "Sigil2": {
            "no-item-sigil": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {}
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "salsa-topped-veggie-flatbread": {},
            "meaty-asparagus-skewer": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: DPS Vindicator (Fractal)
    profession: Vindicator
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "thief-relic": {}
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "no-item-sigil": {}
          },
          "Enhancement": {
            "slaying-potion": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {}
          }
        },
        "lifestealAmount": "4.18"
      }

  - name: DPS Vindicator (Raid)
    profession: Vindicator
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "thief-relic": {}
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "air": {
              "amount": "3.1"
            }
          },
          "Enhancement": {
            "superior-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {}
          }
        },
        "lifestealAmount": "4.18"
      }

  - name: Condition Conduit
    profession: Conduit
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "no-item-sigil": {}
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "weaver": {},
            "berserker": {},
            "renegade": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            }
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "salsa-topped-veggie-flatbread": {},
            "meaty-asparagus-skewer": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Mechanist
    profession: Mechanist
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "balthazar": {},
            "renegade": {},
            "berserker": {},
            "weaver": {},
            "baelfire": {},
            "flame-legion-2": {}
          },
          "Relics": {
            "fractal-relic": {}
          },
          "Sigil1": {
            "geomancy": {}
          },
          "Sigil2": {
            "earth": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {}
          }
        },
        "lifestealAmount": "3.4"
      }

  - name: Condi Amalgam
    profession: Amalgam
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            }
          },
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "bursting": {},
            "geomancy": {
              "amount": ""
            },
            "earth": {
              "amount": ""
            },
            "doom": {
              "amount": ""
            },
            "torment": {
              "amount": ""
            }
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "truffle-risotto": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Amalgam Steamshrieker
    profession: Amalgam
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {}
          },
          "Relics": {
            "steamshrieker-relic": {
              "amount": "4.27"
            }
          },
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "bursting": {},
            "geomancy": {
              "amount": ""
            },
            "earth": {
              "amount": ""
            },
            "doom": {
              "amount": ""
            },
            "torment": {
              "amount": ""
            }
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "truffle-risotto": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: DPS Scourge
    profession: Scourge
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "weaver": {},
            "berserker": {},
            "renegade": {}
          },
          "Relics": {
            "fractal-relic": {}
          },
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "torment": {
              "amount": "1.85"
            }
          },
          "Enhancement": {
            "master-tuning-crystal": {}
          },
          "Nourishment": {
            "meaty-asparagus-skewer": {},
            "cilantro-and-cured-meat-flatbread": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Reaper Spear
    profession: Reaper
    value:
      {
        "extras": {
          "Runes": {
            "krait": {}
          },
          "Relics": {
            "fractal-relic": {}
          },
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "earth": {
              "amount": ""
            }
          },
          "Enhancement": {
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "plate-of-kimchi-pancakes": {},
            "truffle-risotto": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Reaper Scepter
    profession: Reaper
    value:
      {
        "extras": {
          "Runes": {
            "krait": {}
          },
          "Relics": {
            "fractal-relic": {}
          },
          "Sigil1": {
            "no-item-sigil": {}
          },
          "Sigil2": {
            "no-item-sigil": {}
          },
          "Enhancement": {
            "toxic-focusing-crystal": {}
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "plate-of-kimchi-pancakes": {},
            "truffle-risotto": {}
          }
        }
      }

  - name: DPS Harbinger
    profession: Harbinger
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {},
            "demons": {},
            "malice": {}
          },
          "Sigil2": {
            "geomancy-torment-harb": {},
            "earth-torment-harb": {},
            "torment": {
              "amount": "1.85"
            }
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "weaver": {},
            "berserker": {},
            "renegade": {},
            "tormenting": {}
          },
          "Relics": {
            "fractal-relic": {}
          },
          "Nourishment": {
            "meaty-asparagus-skewer": {},
            "cilantro-and-cured-meat-flatbread": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Quickness Condi Harbinger
    profession: Harbinger
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {},
            "demons": {}
          },
          "Sigil2": {
            "torment": {
              "amount": "1.85"
            },
            "geomancy-torment-cwb-alac": {}
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "renegade": {},
            "berserker": {},
            "weaver": {},
            "tormenting": {},
            "firebrand": {}
          },
          "Relics": {
            "fractal-relic": {}
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "salsa-topped-veggie-flatbread": {},
            "meaty-asparagus-skewer": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Deadeye A/D
    profession: Deadeye
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "renegade": {},
            "berserker": {},
            "krait": {},
            "mad-king": {},
            "afflicted": {},
            "thorns": {}
          },
          "Relics": {
            "peitha-relic": {
              "amount": "1.9"
            }
          },
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "earth": {
              "amount": ""
            }
          },
          "Enhancement": {
            "master-tuning-crystal": {}
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Quickness Condi Deadeye Spear
    profession: Deadeye
    value:
      {
        "extras": {
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "renegade": {},
            "berserker": {},
            "krait": {},
            "mad-king": {},
            "afflicted": {},
            "thorns": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            }
          },
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "earth": {
              "amount": ""
            }
          },
          "Enhancement": {
            "master-tuning-crystal": {}
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Thief Spear
    profession: Thief
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "earth": {
              "amount": ""
            }
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "weaver": {},
            "berserker": {},
            "renegade": {},
            "tormenting": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            },
            "blightbringer-relic": {
              "amount": ""
            }
          },
          "Nourishment": {
            "plate-of-kimchi-pancakes": {},
            "salsa-topped-veggie-flatbread": {},
            "cilantro-and-cured-meat-flatbread": {}
          },
          "Enhancement": {
            "toxic-focusing-crystal": {},
            "master-tuning-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Thief A/D
    profession: Thief
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {}
          },
          "Sigil2": {
            "earth": {
              "amount": ""
            }
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "weaver": {},
            "berserker": {},
            "renegade": {},
            "tormenting": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            }
          },
          "Nourishment": {
            "plate-of-kimchi-pancakes": {},
            "salsa-topped-veggie-flatbread": {},
            "cilantro-and-cured-meat-flatbread": {}
          },
          "Enhancement": {
            "toxic-focusing-crystal": {},
            "master-tuning-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Deadeye (Raid)
    profession: Deadeye
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "deadeye-relic": {
              "amount": "95"
            }
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {},
            "accuracy": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {},
            "curry-butternut-squash-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Daredevil Staff
    profession: Daredevil
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {}
          },
          "Relics": {
            "eagle-relic": {
              "amount": ""
            }
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "impact/night/slaying-only-3": {}
          },
          "Enhancement": {
            "superior-sharpening-stone": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-coq-au-vin-with-salsa": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Power Boon Daredevil
    profession: Daredevil
    value:
      {
        "extras": {
          "Runes": {
            "scholar": {},
            "dragonhunter": {},
            "golemancer": {},
            "deadeye": {},
            "eagle": {},
            "infiltration": {},
            "ranger": {},
            "pack": {},
            "fireworks": {},
            "firebrand": {}
          },
          "Relics": {
            "thief-relic": {},
            "mistburn-relic": {}
          },
          "Sigil1": {
            "force": {}
          },
          "Sigil2": {
            "concentration": {}
          },
          "Enhancement": {
            "holographic-super-cheese": {},
            "potent-lucent-oil": {}
          },
          "Nourishment": {
            "cilantro-lime-sous-vide-steak": {},
            "plate-of-beef-carpaccio-with-salsa-garnish": {},
            "spherified-cilantro-oyster-soup": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Daredevil D/D
    profession: Daredevil
    value:
      {
        "extras": {
          "Sigil1": {
            "agony": {},
            "earth": {
              "amount": ""
            }
          },
          "Sigil2": {
            "doom": {}
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "renegade": {},
            "berserker": {},
            "krait": {},
            "mad-king": {},
            "afflicted": {},
            "thorns": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            }
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {},
            "plate-of-kimchi-pancakes": {},
            "bowl-of-kimchi-tofu-stew": {}
          },
          "Enhancement": {
            "master-tuning-crystal": {},
            "toxic-focusing-crystal": {}
          }
        },
        "lifestealAmount": ""
      }

  - name: Condi Specter Spear
    profession: Specter
    value:
      {
        "extras": {
          "Sigil1": {
            "torment": {
              "amount": "1.72"
            },
            "bursting": {}
          },
          "Sigil2": {
            "bursting": {},
            "earth": {
              "amount": ""
            }
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "weaver": {},
            "berserker": {},
            "renegade": {},
            "tormenting": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": "0.39"
            }
          },
          "Nourishment": {
            "cilantro-and-cured-meat-flatbread": {}
          },
          "Enhancement": {
            "toxic-focusing-crystal": {},
            "master-tuning-crystal": {}
          }
        },
        "lifestealAmount": "3.5"
      }

  - name: Condi Specter SC/D
    profession: Specter
    value:
      {
        "extras": {
          "Sigil1": {
            "torment": {
              "amount": "1.72"
            },
            "bursting": {}
          },
          "Sigil2": {
            "doom": {
              "amount": "0.89"
            },
            "bursting": {}
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "weaver": {},
            "berserker": {},
            "renegade": {},
            "tormenting": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": "0.39"
            }
          },
          "Nourishment": {
            "bowl-of-kimchi-tofu-stew": {},
            "cilantro-and-cured-meat-flatbread": {},
            "meaty-asparagus-skewer": {},
            "plate-of-kimchi-pancakes": {}
          },
          "Enhancement": {
            "toxic-focusing-crystal": {},
            "master-tuning-crystal": {}
          }
        },
        "lifestealAmount": "3.5"
      }

  - name: Condi Barrier Specter SC/D
    profession: Specter
    value:
      {
        "extras": {
          "Sigil1": {
            "bursting": {},
            "demons": {},
            "torment": {
              "amount": "1.52"
            }
          },
          "Sigil2": {
            "doom": {
              "amount": "0.89"
            }
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "weaver": {},
            "berserker": {},
            "renegade": {},
            "tormenting": {}
          },
          "Relics": {},
          "Nourishment": {
            "bowl-of-kimchi-tofu-stew": {},
            "cilantro-and-cured-meat-flatbread": {},
            "meaty-asparagus-skewer": {}
          },
          "Enhancement": {
            "magnanimous-tuning-crystal": {}
          }
        },
        "lifestealAmount": "3.5"
      }

  - name: Alacrity Condi Specter
    profession: Specter
    value:
      {
        "extras": {
          "Sigil1": {
            "torment": {
              "amount": "1.52"
            },
            "bursting": {},
            "concentration": {},
            "demons": {},
            "agony": {}
          },
          "Sigil2": {
            "geomancy-doom-alac-specter": {
              "amount": "0.89"
            },
            "geomancy": {
              "amount": "0.89"
            },
            "doom": {
              "amount": "0.89"
            },
            "torment": {
              "amount": "1.52"
            },
            "bursting": {},
            "concentration": {},
            "demons": {},
            "agony": {}
          },
          "Runes": {
            "trapper": {},
            "nightmare": {},
            "tempest": {},
            "lich": {},
            "renegade": {},
            "berserker": {},
            "weaver": {},
            "tormenting": {},
            "leadership": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": "0.45"
            }
          },
          "Nourishment": {
            "salsa-eggs-benedict": {},
            "meaty-asparagus-skewer": {},
            "plate-of-kimchi-pancakes": {},
            "cilantro-and-cured-meat-flatbread": {}
          },
          "Enhancement": {
            "toxic-maintenance-oil": {},
            "magnanimous-tuning-crystal": {},
            "toxic-focusing-crystal": {},
            "master-tuning-crystal": {}
          }
        },
        "lifestealAmount": "2.6"
      }

  - name: Condi Antiquary Spear Generosity
    profession: Antiquary
    value:
      {
        "extras": {
          "Sigil1": {
            "smoldering": {},
            "malice": {},
            "bursting": {},
            "earth": {
              "amount": ""
            },
            "torment": {
              "amount": ""
            }
          },
          "Sigil2": {
            "no-item-sigil": {}
          },
          "Runes": {
            "trapper": {},
            "balthazar": {},
            "nightmare": {},
            "baelfire": {},
            "afflicted": {}
          },
          "Relics": {
            "fractal-relic": {
              "amount": ""
            }
          },
          "Nourishment": {
            "fishy-rice-bowl": {},
            "salsa-topped-veggie-flatbread": {},
            "cilantro-and-cured-meat-flatbread": {}
          },
          "Enhancement": {
            "toxic-focusing-crystal": {},
            "master-tuning-crystal": {}
          }
        },
        "lifestealAmount": ""
      }
